<template>
    <div class="container-fluid">
        <b-card no-body class="my-2">
            <b-card-header class="">
                <b-card-title class="card-title-page-garden-help-default my-1">
                    Staff
                    <b-button variant="garden-help-primary-light" class="btn-bumblebee btn-garden-help float-right"
                        @click="clickAddStaff">Add</b-button>

                </b-card-title>
            </b-card-header>
        </b-card>
        <b-overlay :show="show_overlay" variant="success" :opacity=".5" rounded="sm" style="min-height:100%">
            <b-card no-body>
                <b-card-header>
                    <b-row>
                        <b-col xl="6" lg="8" md="9">
                            <b-input-group class="input-group-search input-group-search-garden-help">
                                <template #prepend>
                                    <font-awesome-icon icon="fa-solid fa-magnifying-glass" size="lg" />
                                </template> <b-form-input v-model="search" class="form-control-garden-help"
                                    placeholder="Search "></b-form-input>
                            </b-input-group>
                        </b-col>
                        <b-col xl="6" lg="4" md="3">
                            <b-button variant="garden-help-filter-info" class="btn-bumblebee btn-garden-help float-right"
                                v-b-toggle.staff-filter-sidebar><img
                                    src="@/assets/images/garden-help/filter-action-default-icon.png" /></b-button>
                        </b-col>
                    </b-row>
                </b-card-header>
                <b-card-body class="px-0">
                    <!-- <b-table class="gardenHelpTable" responsive :items="jobs" :fields="table_fields" details-td-class="text-center">
                <template #cell(created_at)="data" class="text-center">
                    <p class="dateTdSpan text-center">{{ data.value.substring(0, 9) }}</p>
                    <p class="text-center">{{ data.value.substring(10) }}</p>
                </template>
                <template #cell(scheduled_at)="data" class="text-center">
                    <p class="dateTdSpan text-center">{{ data.value.substring(0, 9) }}</p>
                    <p class="text-center">{{ data.value.substring(10) }}</p>
                </template>
            </b-table> -->

                    <b-table-simple class="gardenHelpTable cursor-auto" responsive stacked="md">
                        <b-thead>
                            <b-tr>
                                <b-th> Name</b-th>
                                <b-th> Email</b-th>
                                <b-th> Location</b-th>
                                <b-th> Service Type</b-th>
                                <b-th> Experience Level</b-th>
                                <b-th> Last Activity</b-th>
                                <b-th></b-th>
                            </b-tr>
                        </b-thead>
                        <b-tbody v-if="staff_list.length > 0">
                            <b-tr v-for="(staff, index) in staff_list" :key="index">
                                <b-td stacked-heading="Name">{{ staff.name }}</b-td>
                                <b-td stacked-heading="Email">{{ staff.email }}</b-td>
                                <b-td stacked-heading="Location" class="text-center">
                                    <img src="@/assets/images/garden-help/location-icon.png" :id="'location_' + staff.id" />
                                    <b-popover custom-class="popover-garden-help" :target="'location_' + staff.id"
                                        triggers="hover" placement="left">
                                        {{ staff.address }}
                                    </b-popover>
                                </b-td>
                                <b-td stacked-heading="Service Type" class="serviceTd"
                                    v-html="getServicesNamesFromObject(staff.services, true)"></b-td>
                                <b-td stacked-heading="Experience Level">{{ staff.experience_level }}</b-td>
                                <b-td stacked-heading="Last Activity">{{ staff.last_activity }}</b-td>
                                <b-td class="text-center">
                                    <b-dropdown id="dropdown-dropleft"  dropleft no-caret variant="link" toggle-class="p-0"
                                        class="dropdown-actions-garden-help m-2 " @shown="showDropdown" @hidden="hideDropdown" >
                                        <template #button-content> <img
                                                src="@/assets/images/garden-help/more-actions-icon.png" />
                                        </template>
                                        <b-dropdown-item :href="'list/view/' + staff.id" class="my-1">
                                            <font-awesome-icon icon="fa-solid fa-eye" class="mr-1" />
                                            View</b-dropdown-item>
                                        <b-dropdown-item @click="clickEditStaff(index)">
                                            <font-awesome-icon icon="fa-solid fa-pen" class="mr-1" />
                                            Edit</b-dropdown-item>
                                        <b-dropdown-item @click="clickDeleteStaff(staff.id)" class="my-1">
                                            <font-awesome-icon icon="fa-solid fa-trash-can" class="mr-1" />
                                            Delete</b-dropdown-item>
                                    </b-dropdown>
                                </b-td>

                            </b-tr>
                            
                        </b-tbody>
                        <b-tbody v-else>
                            <b-tr>
                                <b-td :colspan="type == 'requests' ? 7 : 8" class="text-center cursor-initial">
                                    No results found
                                </b-td>
                            </b-tr>
                        </b-tbody>
                    </b-table-simple>
                    <!-- filter sidebar -->
                    <b-sidebar id="staff-filter-sidebar" class="filter-sidebar-garden-help" title="Sidebar" right shadow
                        ref="sidebar_filter" :no-close-on-backdrop="false" :backdrop="true">
                        <div class="px-3 py-2">
                            <InputCheckboxFilter field_label="Service Categories" :options="servies_list"
                                :field_model.sync="service_filter" />

                            <!-- <b-form-group label="Distance" label-for="fulfilment_date"
                                label-class="form-label-filter-garden-help text-left ">
                                <vue-slider class="vue-slider-garden-help mt-3" v-model="distance" :min="0" :max="60"
                                    :interval="1" :dotSize="[22, 22]" height="8px" tooltip="always"
                                    :tooltip-formatter="'{value}km'"></vue-slider>
                            </b-form-group> -->

                            <InputCheckboxFilter field_label="Experience Level" :options="experience_levels_list"
                                :field_model.sync="experience_level_filter" />

                            <!-- <InputCheckboxFilter field_label="Property Category" :options="property_types_list"
                                :field_model.sync="property_type_filter" />

                            <InputCheckboxFilter v-if="type == 'current'" field_label="Job Status" :options="status_list"
                                :field_model.sync="status_filter" /> -->
                        </div>

                        <template #header="{ hide }">
                            <b-row class="w-100 mx-0">
                                <b-col cols="10" class="pl-0">
                                    <h2 class="filter-header w-100">
                                        <img src="@/assets/images/garden-help/filter-icon.png" /> Filter
                                    </h2>
                                </b-col>
                                <b-col cols="2" class="px-0" align-self="center">
                                    <b-button variant="garden-help-info-light"
                                        class=" btn-bumblebee btn-garden-help btn-close-action  d-block float-right  m-auto "
                                        @click="hide">x</b-button></b-col>
                            </b-row>
                        </template>
                        <template #footer>

                            <b-row class="p-2  w-100 m-auto" cols="2">
                                <b-col>
                                    <b-button variant="garden-help-primary" class="btn-bumblebee btn-garden-help"
                                        @click="clickFilter">Filter</b-button>
                                </b-col>
                                <b-col>
                                    <b-button variant="garden-help-light-outline" class="btn-bumblebee btn-garden-help"
                                        @click="clickClearFilters">Clear All</b-button>
                                </b-col>
                            </b-row>
                        </template>
                    </b-sidebar>

                </b-card-body>
            </b-card>
            <!-- pagination -->
            <b-card class="card-transparent-background m-0" no-body>
                <b-card-body class="px-2 py-0">
                    <b-row cols="1" cols-md="2">
                        <b-col>
                            <p class="data-list-info-garden-help">
                                Showing {{ from_page }} to {{ to_page }} of
                                {{ total_items }} entries
                            </p>
                        </b-col>
                        <b-col>
                            <b-pagination class="pagination-garden-help" v-model="currentPage" :total-rows="total_items"
                                :per-page="perPage" limit="7" @change="changePage" size="md"></b-pagination></b-col>
                    </b-row>
                </b-card-body>
            </b-card>
        </b-overlay>
        <StaffInfoModal :client_name="client_name" :type="type" :company_id="user_id" :staff_id="selected_staff_id"
            :staff_obj_prop="selected_staff" />
        <DeleteStaff :client_name="client_name" :company_id="user_id" :staff_id="selected_staff_id" />
    </div>
</template>  

<script>
import axios from "axios";
import $ from "jquery";
import InputCheckboxFilter from "../../components/InputCheckboxFilter.vue";

import {
    listServicesRequest,
    listExperienceLevels, getServicesNamesFromObject
} from "@/utils/helper-functions-garden-help.js"

import StaffInfoModal from '../modals/StaffInfoModal.vue'
import DeleteStaff from "../modals/DeleteStaff.vue";

export default {
    name: "GardenHelpStaffList",
    components: { InputCheckboxFilter, StaffInfoModal, DeleteStaff },
    data() {
        return {
            show_overlay: false,
            client_name: "GARDENHELP",
            user_type: localStorage.getItem('user_type'),
            user_id: null, // logined user

            staff_list: [
                // {
                //     id: 1,
                //     name: "sara reda",
                //     first_name: 'sara',
                //     last_name: "reda",
                //     phone: "+2012234523456",
                //     email: "sarayassen.118@gmail.com",
                //     last_activity: "12 June 2023",
                //     // location: "Dublin",
                //     services: [{
                //         description: "Designing areas like fences, patios, decks and paths",
                //         id: 1,
                //         name: "Garden Design",

                //     }],
                //     experience_level: "0-2 years",
                //     address: "Cairo, Egypt",
                //     city: "Cairo",
                //     county: "",
                //     latitude: 31.212345213,
                //     longitude: 30.213454321
                // },
                // {
                //     id: 2,
                //     name: "sara reda",
                //     email: "sarayassen.118@gmail.com",
                //     last_activity: "12 June 2023",
                //     // location: "Dublin",
                //     services: [{
                //         description: "Designing areas like fences, patios, decks and paths",
                //         id: 1,
                //         name: "Garden Design",

                //     }],
                //     experience_level: "0-2 years",
                //     address: "Cairo, Egypt"
                // }
            ],

            search: null,
            // pagination
            perPage: 10,
            currentPage: 1,
            total_items: 0,
            from_page: 0,
            to_page: 0,
            // filter data
            servies_list: [],
            service_filter: [],
            experience_levels_list: [],
            experience_level_filter: [],

            selected_staff_id: null,
            selected_staff: null,
            type: null,
        }
    },

    mounted() {
        let user = JSON.parse(window.localStorage.getItem("user"));
        this.user_id = user.id

        this.getFilterData();
        this.getStaffList()

        console.log(this.experience_levels_list)
        console.log(this.servies_list)

        $('.table-responsive').on('show.bs.dropdown', function () {
            $('.table-responsive').css("overflow", "inherit");
        });

        $('.table-responsive').on('hide.bs.dropdown', function () {
            $('.table-responsive').css("overflow", "auto");
        })
    },
    watch: {
        search(newval) {
            console.log("search", this.search)
            this.getStaffList()
        }
    },
    methods: {
        listServicesRequest,
        listExperienceLevels,
        getServicesNamesFromObject,
        async getFilterData() {
            this.experience_levels_list = this.listExperienceLevels();
            this.servies_list = await this.listServicesRequest(null);
        },
        changePage(value) {
            console.log("change page", value);
            this.currentPage = value
            this.getStaffList()
        },
        clickClearFilters() {
            this.service_filter = [];
            this.experience_level_filter = [];
        },
        clickFilter() {
            console.log("click filter")
            this.currentPage = 1

            console.log("Service", this.service_filter)
            console.log("experience", this.experience_level_filter)

            console.log(this.$refs.sidebar_filter)
            this.$refs.sidebar_filter.hide()
            this.getStaffList()
        },
        getStaffList() {
            console.log("in get staff list", this.user_id)

            this.show_overlay = true
            axios
                .post("/operator/contractor/list-staff", {}, {
                    headers: {
                        Accept: "application/json",
                        "Content-Type": "application/json",
                        client: this.client_name,
                        Authorization:
                            "Bearer " +
                            JSON.parse(window.localStorage.getItem("user")).access_token,
                    },
                })
                .then((response) => {
                    console.log(response)
                    console.log(response.data)
                    console.log(response)
                    this.staff_list = response.data.data;

                    this.total_items = response.data.meta.total
                    if (response.data.meta.total == 0) {
                        this.from_page = 0
                        this.to_page = 0
                    } else {
                        this.from_page = ((this.currentPage - 1) * this.perPage) + 1
                        this.to_page = this.currentPage * this.perPage > response.data.meta.total ? response.data.meta.total : this.currentPage * this.perPage
                    }
                    this.show_overlay = false

                });
        },
        clickDeleteStaff(id) {
            console.log("delete staff", id)
            this.selected_staff_id = id
            this.$root.$emit("bv::show::modal", "deleteStaffModal");
        },
        clickAddStaff() {
            this.type = 'add';
            this.selected_staff = null;

            let temp = this
            setTimeout(function () {
                temp.$bvModal.show('saveStaffDataModal')
            }, 200);
        },
        clickEditStaff(index) {
            console.log("click edit staff", index)
            console.log(this.staff_list[index])

            this.type = 'edit'
            this.selected_staff_id = this.staff_list[index].id
            this.selected_staff = {...this.staff_list[index]}

            let temp = this
            // this.show_overlay = true
            setTimeout(function () {
                console.log(temp.selected_staff_id)
                console.log(temp.selected_staff)

                temp.$bvModal.show('saveStaffDataModal')
                temp.show_overlay = false
            }, 500);

        },
        showDropdown(){
            console.log("show dropdown")
            $('.table-responsive').css("overflow-y", "auto");

        },
        hideDropdown(){
            console.log("hide dropdown")            
            $('.table-responsive').css("overflow-y", "auto");

        },
    }

};
</script>


// WEBPACK FOOTER //
// src/projects/garden_help/contractor/staff/List.vue